import * as types from './types';

export const setMetricFilter = (metricFilter) => ({
  type: types.SET_METRIC_FILTER,
  metricFilter,
});

// workaround for the race conditions select + slice workflow
// TODO: this has to be cleaned up as part of metric/order by re-write
export const initMetricFilter = (metricFilter) => ({
  type: types.INIT_METRIC_FILTER,
  metricFilter,
});

export const addMetricFilter = (metricFilter) => ({
  type: types.ADD_METRIC_FILTER,
  metricFilter,
});

export const removeMetricFilter = (metricFilter) => ({
  type: types.REMOVE_METRIC_FILTER,
  metricFilter,
});

export const clearMetricFilter = () => ({
  type: types.CLEAR_METRIC_FILTER,
});

export const setDimensions = (dimensions) => ({
  type: types.SET_DIMENSIONS,
  dimensions,
});

export const setDimensionsToNA = (dimensions) => ({
  type: types.SET_DIMENIONS_TO_NA,
  dimensions,
});

export const updateDimension = (dimension, newDimension) => ({
  type: types.UPDATE_DIMENSION,
  dimension,
  newDimension,
});

export const addDimension = (dimension) => ({
  type: types.ADD_DIMENSION,
  dimension,
});

export const removeDimension = (dimension) => ({
  type: types.REMOVE_DIMENSION,
  dimension,
});

export const setSelectedDimension = (dimensionIndex, dimension) => ({
  type: types.SET_SELECTED_DIMENSION,
  dimensionIndex,
  dimension,
});

export const swapSelectedDimensions = (currentIndex, dimension, swapIndex, swapDimension) => ({
  type: types.SWAP_SELECTED_DIMENSION,
  currentIndex,
  dimension,
  swapIndex,
  swapDimension,
});

export const dimensionDrilldown = (dimension, row) => ({
  type: types.DIMENSION_DRILLDOWN,
  dimension,
  row,
});

export const multiDimensionDrilldown = (payload) => ({
  type: types.MULTI_DIMENSION_DRILLDOWN,
  payload,
});

// filter bar
export const initRule = () => ({
  type: types.INIT_RULE,
});

export const toggleRule = (dimension, row) => ({
  type: types.TOGGLE_RULE,
  dimension,
  row,
});

export const setRules = (rules) => ({
  type: types.SET_RULES,
  rules,
});

export const removeRule = (rule) => ({
  type: types.REMOVE_RULE,
  rule,
});

export const updateRule = (rule, op) => ({
  type: types.UPDATE_RULE,
  rule,
  op,
});

export const applyFilter = (params) => ({
  type: types.APPLY_FILTER,
  params,
});

export const resetFilter = () => ({
  type: types.RESET_FILTER,
});

// compare bar
export const initCompare = (key) => ({
  type: types.INIT_COMPARE,
  compareType: key,
});

export const initFilter = (params: any = null) => ({
  type: types.INIT_COMPARE_FILTER,
  params,
});

export const addFilter = (filter) => ({
  type: types.ADD_COMPARE_FILTER,
  filter,
});

export const removeFilter = (filter, idx) => ({
  type: types.REMOVE_COMPARE_FILTER,
  filter,
  idx,
});

export const setFilters = (filters) => ({
  type: types.SET_COMPARE_FILTERS,
  filters,
});

export const compareFilters = (params) => ({
  type: types.COMPARE_FILTERS,
  params,
});

export const compareFiltersOnTrends = () => ({
  type: types.COMPARE_FILTERS_ON_TRENDS,
});

export const setActiveFilter = (activeFilterIndex) => ({
  type: types.SET_ACTIVE_FILTER,
  activeFilterIndex,
});

export const toggleCompareRule = (dimension, row) => ({
  type: types.TOGGLE_COMPARE_RULE,
  dimension,
  row,
});

export const addSavedFilter = (savedFilter) => ({
  type: types.ADD_SAVED_FILTER,
  savedFilter,
});

export const addTopFilters = (dimension, rows) => ({
  type: types.ADD_TOP_COMPARE_FILTERS,
  dimension,
  rows,
});

export const updateActiveFilter = (filter) => ({
  type: types.UPDATE_ACTIVE_FILTER,
  filter,
});

export const removeCompareRule = (rule) => ({
  type: types.REMOVE_COMPARE_RULE,
  rule,
});

export const updateCompareRule = (rule, op) => ({
  type: types.UPDATE_COMPARE_RULE,
  rule,
  op,
});

export const resetCompare = () => ({
  type: types.RESET_COMPARE,
});

export const modifyCompareInit = (config) => ({
  type: types.MODIFY_COMPARE_INIT,
  config,
});

export const setSharedState = (base = {}) => ({
  type: types.SET_SHARED_STATE,
  base,
});

export const setViewContext = (context) => ({
  type: types.SET_VIEW_CONTEXT,
  context,
});

export const setGlobalOrderByMetric = (metric) => ({
  type: types.SET_GLOBAL_ORDER_BY,
  metric,
});

export const setDimensionMetrics = (metrics) => ({
  type: types.SET_DIMENSION_METRICS,
  metrics,
});

export const setDimensionsMetricsToNA = (metrics) => ({
  type: types.SET_DIMENIONS_METRICS_TO_NA,
  metrics,
});

export const applyErrorFilter = (code, metric) => ({
  type: types.APPLY_ERROR_FILTER,
  code,
  metric,
});

export const applyCompareFiltersOnTrends = (filters) => ({
  type: types.APPLY_COMPARE_FILTERS_ON_TRENDS,
  filters,
});

export const clearCompareFiltersOnTrends = () => ({
  type: types.CLEAR_COMPARE_FILTERS_ON_TRENDS,
});

export const removeCompareFiltersOnTrends = (idx) => ({
  type: types.REMOVE_COMPARE_FILTERS_ON_TRENDS,
  idx,
});

export const editCompareFiltersOnTrends = () => ({
  type: types.EDIT_COMPARE_FILTERS_ON_TRENDS,
});

export const addCompareFilterOnTrends = (filter) => ({
  type: types.ADD_COMPARE_FILTER_ON_TRENDS,
  filter,
});

export const quickCompareFilter = (dimension, row, options = {}) => ({
  type: types.QUICK_COMPARE_FILTER,
  dimension,
  row,
  options,
});

export const quickCompareTopFilters = (dimension, rows) => ({
  type: types.QUICK_COMPARE_TOP_FILTERS,
  dimension,
  rows,
});

export const highlightCompareFilter = (idx, toggleState) => ({
  type: types.HIGHLIGHT_COMPARE_FILTER,
  idx,
  toggleState,
});

export const persistAtoms = () => ({
  type: types.PERSIST_ATOMS,
});

export const persistWidgets = () => ({
  type: types.PERSIST_WIDGETS,
});
